// extracted by mini-css-extract-plugin
export default {"Image":"PartnersSection_Image__0dmkH"};